import { AfterViewInit, Component, ElementRef, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'src/app/core/services/loader.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent {

  constructor(
    public dialogRef: MatDialogRef<NotificationComponent>,
    public loader: LoaderService,
    public fb: FormBuilder,
    public translate: TranslateService,
    private el: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  close() {
    this.dialogRef.close(true);
  }

  accept() {
    this.dialogRef.close(true);
  }
  
  notAccept() {
    this.dialogRef.close(false);
  }
}

